module.exports = __webpack_public_path__ + "img/sign_230590699_1.805f6b9b.png";